var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.rootClass, ( _obj = {}, _obj[(_vm.rootClass + "--image")] = _vm.showLogo, _obj )],attrs:{"aria-hidden":_vm.decorative ? 'true' : undefined}},[(_vm.showLogo)?_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.decorative ? '' : _vm.altText,"loading":"lazy"},on:{"error":function($event){_vm.imageFailed = true}}}):_c('span',[_vm._v(_vm._s(_vm.initial))])])}
var staticRenderFns = []

export { render, staticRenderFns }